(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ywm-glossary"]) return;
  try {
    
(function() {
$('body').on('click', '.ywm_faq__question', function() {
//console.log('clicked');
$(this).next('.ywm_faq__answer').slideToggle(150).toggleClass('active');
$(this).toggleClass('active');
$(this).children('.toggle-icon').html('<i class="fas fa-toggle-on"></i>');
});

var otherMenuItems = $(".ywm_faq__question.link").not($(this));
$(otherMenuItems).next('.ywm_faq__answer').slideUp(150).removeClass('active');
$(otherMenuItems).children('.toggle-icon').html('<i class="fas fa-toggle-off"></i>');

$(document).on('shopify:block:select', '#shopify-section-ywm-faq', function(event) {
$(event.target).find('.ywm_faq__answer').slideDown(150);
});

$(document).on('shopify:block:deselect', '#shopify-section-ywm-faq', function(event) {
$(event.target).find('.ywm_faq__answer').slideUp(150);
});


}());

  } catch(e) { console.error(e); }
})();
})();
